import Logo from 'assets/images/logo.svg';

import { FC } from 'react';
// MUI
import { Box, Container, Link } from '@mui/material';

const links = [
  { href: 'https://www.casechronology.com/about', label: 'About' },
  { href: 'https://www.casechronology.com/#contact-us', label: 'Contact Us' }
]

const Header:FC = () => {
  return (
    <Box sx={{ backgroundColor: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', zIndex: 6 }}>
      <Container maxWidth="lg" component="header" sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2
      }}>
        <img src={Logo} alt="Case Chronology" />
        <nav>
          <Box component="ul" sx={{ display: 'flex', listStyle: 'none', gap: { xs: 2, md: 4 }, m: 0, p: 0 }}>
            {links.map((link) => (
              <li key={link.label}>
                <Link
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  sx={{
                    fontSize: { xs: 14, sm: 16 },
                    fontWeight: 500,
                    textDecoration: 'none',
                    cursor: 'pointer',
                    color: 'text.primary',
                    transition: 'color 0.3s',
                    '&:hover': {
                      color: (theme) => theme.palette.primary.main,
                    }
                  }}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </Box>
        </nav>
      </Container>
    </Box>
  );
}

export default Header;
